import { render, staticRenderFns } from "./IdoneitaElettrocardiogrammaViewComponent.vue?vue&type=template&id=22231f58"
import script from "./IdoneitaElettrocardiogrammaViewComponent.vue?vue&type=script&lang=js"
export * from "./IdoneitaElettrocardiogrammaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports